import script from "./AppIcon.vue?vue&type=script&lang=js"
export * from "./AppIcon.vue?vue&type=script&lang=js"

import "./AppIcon.vue?vue&type=style&index=0&id=1901f289&scoped=true&lang=css"

import exportComponent from "/Users/raulbajmuhametov/work/vue/grany/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1901f289"]])

export default __exports__